import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=52a7c338&scoped=true&lang=pug"
import script from "./AlertComponent.vue?vue&type=script&lang=ts"
export * from "./AlertComponent.vue?vue&type=script&lang=ts"
import style0 from "./AlertComponent.vue?vue&type=style&index=0&id=52a7c338&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a7c338",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52a7c338')) {
      api.createRecord('52a7c338', component.options)
    } else {
      api.reload('52a7c338', component.options)
    }
    module.hot.accept("./AlertComponent.vue?vue&type=template&id=52a7c338&scoped=true&lang=pug", function () {
      api.rerender('52a7c338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Alert/AlertComponent.vue"
export default component.exports